export const SOURCE_PAGES = {
    CLP: 'clp',
    CLP_POST_ENROLL: 'clppostenroll',
    COURSE_TAKING: 'coursetaking',
    FREE_RESOURCE: 'freeresource',
    HIGH_RATING: 'highrating',
    INVITE: 'invite',
    MY_COURSES_DROPDOWN: 'my_courses_dropdown',
    POST_ENROLL: 'postenroll',
    PREMIUM_CLP: 'premium_clp',
};

export const SHARE_TYPES = {
    COURSE: 'course',
    INVITE: 'invite',
    FREE_RESOURCE: 'freeresource',
};

/**
 * Suspicious patterns for detecting potentially harmful content in user messages
 * Based on OWASP XSS Prevention recommendations:
 * - https://cheatsheetseries.owasp.org/cheatsheets/XSS_Filter_Evasion_Cheat_Sheet.html
 * - https://cheatsheetseries.owasp.org/cheatsheets/Cross_Site_Scripting_Prevention_Cheat_Sheet.html
 */
export const SUSPICIOUS_PATTERNS = [
    /<script[\s>]/i, // <script> tags
    /<iframe[\s>]/i, // <iframe> tags
    /javascript:/i, // javascript: protocol
    /on\w+\s*=/i, // Event handlers like onclick=, onerror=, etc.
    /<embed[\s>]/i, // <embed> tags
    /<object[\s>]/i, // <object> tags
    /<link[\s>]/i, // <link> tags
    /<style[\s>]/i, // <style> tags
    /<meta[\s>]/i, // <meta> tags
    /data:text\/html/i, // data:text/html protocol
    /vbscript:/i, // vbscript: protocol
    /<form[\s>]/i, // <form> tags
];
